import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import Button from 'components/Buttons/Button';
import InputFileZone from 'components/Inputs/inputFileZone';
import IOFileLoading from 'components/IOFileLoading/components';
import { useSelector } from 'react-redux';
import { getInvestmentAssetsMassiveTemplate, uploadInvestmentAssetsMassive } from 'modules/investmentAssets/repository';
import OutputErrors from 'components/Inputs/outputErrors';

function PopupMassive({ onClose, onSuccess, type }) {
  const [document, setDocument] = useState();
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const literals = useSelector((state) => state.i18n.literals.funds);
  const literalsCommon = useSelector((state) => state.i18n.literals.common);

  const handleDownloadTemplate = async () => {
    setDownloadingExcel(true);
    await getInvestmentAssetsMassiveTemplate(type);
    setDownloadingExcel(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await uploadInvestmentAssetsMassive(document, type);
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup
      title={literals.uploadExcel}
      onClose={onClose}
    >
      <p>
        <span className='link-effect fw-b' onClick={handleDownloadTemplate}>
          Download the template
        </span>
        <span>&nbsp;</span>
        {literals.uploadDescription}
      </p>
      <InputFileZone value={document} onChange={setDocument} />

      <div className='buttons'>
        <Button
          text={literalsCommon.send}
          onClick={handleSubmit}
          loading={loading}
        />
      </div>
      <OutputErrors errors={error} className='mt-3' />
      {downloadingExcel && <IOFileLoading mode='download' file={{ name: 'template.xlsx' }} />}
    </Popup>
  );
}

PopupMassive.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default PopupMassive;
